
import React from 'react'

export default function BasicInfoComponent({ leadValues, productListData, userInfo, handleChange }: any) {

    return (


        <div className="w-full font-bold space-y-4">
            {/* Email & Phone Number */}
            <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex-1">
                    <label className="block text-xs font-bold mb-1">Email</label>
                    <div className="border border-black/50 text-xs rounded py-2 px-3 bg-gray-50">
                        {userInfo[0]?.Message?.Email || "N/A"}
                    </div>
                </div>
                <div className="flex-1">
                    <label className="block text-xs font-bold mb-1">Phone Number</label>
                    <div className="border border-black/50 text-xs rounded py-2 px-3 bg-gray-50">
                        {userInfo[0]?.Message?.PhoneNumber || "N/A"}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1  gap-4">
                <div className="w-1/2">
                    <label
                        className="block text-xs font-bold mb-1"
                    >
                        Product <span className="text-red-500">*</span>
                    </label>
                    <select
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        id="default"

                        onChange={(event: any) => {
                            handleChange(
                                event.target.value, 'mobilityProdcutId'
                            )
                        }}
                        value={leadValues?.mobilityProdcutId}
                    >

                        <option >Choose Product</option>
                        {productListData?.result?.items?.map((item: any, index: any) => (
                            <option value={item.Id} key={index}>{item.Name}</option>
                        )
                        )}

                    </select>
                </div>

            </div>

            <div className="w-full">
                <label className="block text-xs font-bold mb-1">Additonal Information</label>

                <textarea
                    name={"additionainfo"}
                    placeholder=""
                    className="w-full h-20 border border-black/50 text-xs rounded px-3 py-2 bg-gray-50"
                    onChange={(event: any) => {
                        handleChange(
                            event.target.value,
                            'Description'
                        )
                    }}
                    value={leadValues?.Description}
                />
            </div>



        </div>







    )
}